<div class="skeleton-card">
    @if (showHeader) {
        <div class="skeleton-card__header">
            <div class="skeleton-card__bar skeleton-card__bar--{{ headerWidth }} skeleton"></div>
            @if (showSubheader) {
                <div
                    class="skeleton-card__bar skeleton-card__bar--{{ subheaderWidth }} skeleton"
                ></div>
            }
        </div>
    }
    <div class="skeleton-card__content">
        @for (line of lineArray; track $index; let lineIndex = $index) {
            <div
                class="skeleton-card__line skeleton-card__line--{{
                    lineWidths[lineIndex] || 'm'
                }} skeleton"
            ></div>
        }
    </div>
    @if (showActions && actionsCount > 0) {
        <div class="skeleton-card__actions">
            @for (action of actionArray; track $index) {
                <div class="skeleton-card__action skeleton"></div>
            }
        </div>
    }
</div>
